import { createApi } from '@reduxjs/toolkit/query/react';

import { IReaction, IReactionSummary } from 'constants/types';

import { API_URLS, REQUEST_METHOD } from '../constants/global';
import { baseQueryForumFormData } from './baseQuery';

export const reactionManagement = createApi({
  reducerPath: 'reactionApi',
  baseQuery: baseQueryForumFormData,
  endpoints: (builder) => ({
    addReaction: builder.mutation<void, IReaction>({
      query: (newReaction) => ({
        url: API_URLS.REACTION,
        method: REQUEST_METHOD.POST,
        body: newReaction,
      }),
    }),
    deleteReaction: builder.mutation<void, string>({
      query: (id) => ({
        url: `${API_URLS.REACTION}/${id}`,
        method: REQUEST_METHOD.DELETE,
      }),
    }),

    getUserReaction: builder.query<IReaction, string>({
      query: (postId) => ({
        url: `${API_URLS.REACTION}/${postId}`,
        method: REQUEST_METHOD.GET,
      }),
    }),

    getReactionsSummary: builder.query<IReactionSummary, string>({
      query: (postId) => ({
        url: `${API_URLS.REACTION}/${postId}/${API_URLS.SUMMARY}`,
        method: REQUEST_METHOD.GET,
      }),
    }),
  }),
});

export const {
  useAddReactionMutation,
  useDeleteReactionMutation,
  useGetUserReactionQuery,
  useGetReactionsSummaryQuery,
} = reactionManagement;
